function $0b98cd1c57b9787e$export$3ae94a2503e890a1(date) {
    var newDate = new Date(date);
    var month = newDate.getMonth();
    var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    var day = newDate.getDate();
    return `${months[Number(month)]} ${day}`;
}


function $f64d5b2549d9d5cf$export$71511d61b312f219(x) {
    return document.getElementById(x);
}
function $f64d5b2549d9d5cf$export$3d7cd8ed57263b30(tag, classes) {
    const el = document.createElement(tag);
    el.setAttribute("class", classes);
    return el;
}
function $f64d5b2549d9d5cf$export$c091916f1530334c(e, opLimit) {
    opLimit = opLimit || 1;
    e.style.opacity = opLimit;
    (function fade(x) {
        (e.style.opacity -= 0.1) < 0 ? e.classList.add("no-display") : setTimeout(fade, 40);
    })();
}
function $f64d5b2549d9d5cf$export$82e6205b15e6c637(e, flex, opLimit) {
    if (!flex) e.classList.remove("no-display");
    else {
        e.classList.remove("no-display");
        e.classList.add("flex-container");
    }
    let opacity = 0;
    opLimit = opLimit || 1;
    var interval = setInterval(()=>{
        if (opacity < opLimit) {
            opacity += 0.1;
            e.style.opacity = opacity;
        } else clearInterval(interval);
    }, 40);
}
//OVERLAYS
function $f64d5b2549d9d5cf$var$overlaySwitch(elClass) {
    let el, closeEl;
    switch(elClass){
        case "image-overlay-change":
            el = $f64d5b2549d9d5cf$export$71511d61b312f219("imgOverlay");
            closeEl = $f64d5b2549d9d5cf$export$71511d61b312f219("imgOverlay");
    }
    return {
        el: el,
        closeEl: closeEl
    };
}
function $f64d5b2549d9d5cf$export$2539dfcbe9b5d16c(e) {
    const elClass = this.getAttribute("data-class");
    const el = $f64d5b2549d9d5cf$var$overlaySwitch(elClass).el;
    const closeEl = $f64d5b2549d9d5cf$var$overlaySwitch(elClass).closeEl;
    $f64d5b2549d9d5cf$var$hideOverlay(el, closeEl, elClass, 0.8);
}
function $f64d5b2549d9d5cf$export$85f1bfb258290b46(el, closeEl, elClass) {
    el.setAttribute("data-class", elClass);
    closeEl.setAttribute("data-class", elClass);
    overlay.setAttribute("data-class", elClass);
    $f64d5b2549d9d5cf$export$82e6205b15e6c637(overlay, false);
    document.documentElement.classList.add("no-scroll");
    el.style.visibility = "visible";
    el.classList.add(elClass);
    closeEl.style.visibility = "visible";
}
function $f64d5b2549d9d5cf$var$hideOverlay(el, closeEl, elClass, opLimit) {
    opLimit = opLimit || 1;
    document.documentElement.classList.remove("no-scroll");
    el.classList.remove(elClass);
    el.style.visibility = "hidden";
    closeEl.style.visibility = "hidden";
    setTimeout(()=>{
        $f64d5b2549d9d5cf$export$c091916f1530334c(overlay, opLimit);
    }, 400);
}
function $f64d5b2549d9d5cf$export$db95ad3a9fbc9f60(loading, spinner, button) {
    if (loading) {
        spinner.classList.remove("no-display");
        button.classList.add("no-display");
    } else {
        spinner.classList.add("no-display");
        button.classList.remove("no-display");
    }
}
var $f64d5b2549d9d5cf$export$e85650ebb7296dad = function(isLoading, btn) {
    const spinner = btn.querySelector(".spinner");
    const button = btn.querySelector(".btn-span");
    if (isLoading) {
        btn.disabled = true;
        btn.classList.add("btn-disabled");
    } else {
        btn.disabled = false;
        btn.classList.remove("btn-disabled");
    }
    $f64d5b2549d9d5cf$export$db95ad3a9fbc9f60(isLoading, spinner, button);
};


var $54b47fc030b7b21e$var$body = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("body"), $54b47fc030b7b21e$var$bckgd = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("bckgd"), $54b47fc030b7b21e$var$overlay = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("overlay"), $54b47fc030b7b21e$var$imgOverlay = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("imgOverlay"), $54b47fc030b7b21e$var$nav = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("nav"), $54b47fc030b7b21e$var$main = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("main"), $54b47fc030b7b21e$var$pageFooter = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("pageFooter");
//ON PAGE LOAD
document.addEventListener("DOMContentLoaded", $54b47fc030b7b21e$var$onDOMLoaded);
function $54b47fc030b7b21e$var$onDOMLoaded() {
    const page = $54b47fc030b7b21e$var$body.getAttribute("data-page");
    $54b47fc030b7b21e$var$handleActiveMenu(page);
    if (page != "will-be" && page != "ask") $54b47fc030b7b21e$var$bckgd.style.opacity = 0.1;
    $54b47fc030b7b21e$var$main.style.opacity = 1;
    $54b47fc030b7b21e$var$pageFooter.classList.remove("transform-footer");
    if (page === "was") {
        (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("wasHeader").classList.remove("transform-header");
        $54b47fc030b7b21e$var$addWasListeners();
    } else if (page === "will-be") $54b47fc030b7b21e$var$handleUpcomingShows();
    else if (page === "ask") $54b47fc030b7b21e$var$addContactListeners();
    $54b47fc030b7b21e$var$addGlobalListeners();
}
function $54b47fc030b7b21e$var$handleActiveMenu(page) {
    const menuItems = $54b47fc030b7b21e$var$nav.querySelectorAll(".nav-items");
    const target = Array.from(menuItems).find((node)=>node.getAttribute("data-page") === page);
    if (!target) return;
    target.classList.add("nav-active");
}
//GLOBAL LISTENERS
function $54b47fc030b7b21e$var$addGlobalListeners() {
    const hamburger = document.querySelector(".hamburger");
    hamburger.addEventListener("click", $54b47fc030b7b21e$var$toggleHamb, false);
    const images = document.querySelectorAll(".images");
    images.forEach((image)=>{
        image.addEventListener("click", $54b47fc030b7b21e$var$onImgOverlay, false);
    });
    const overlays = [
        $54b47fc030b7b21e$var$overlay,
        $54b47fc030b7b21e$var$imgOverlay
    ];
    overlays.forEach((e)=>{
        e.addEventListener("click", (0, $f64d5b2549d9d5cf$export$2539dfcbe9b5d16c), false);
    });
    const videos = document.querySelectorAll(".video-wrapper");
    videos.forEach((vid)=>{
        vid.addEventListener("click", $54b47fc030b7b21e$var$onVidClick, false);
    });
    document.documentElement.addEventListener("touchstart", function(e) {
    //hover behaviour on touch devices
    });
}
//WAS LISTENERS
function $54b47fc030b7b21e$var$addWasListeners() {
    const wasBtns = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("wasHeader").querySelectorAll(".was-header-item");
    wasBtns.forEach((btn)=>{
        btn.addEventListener("click", $54b47fc030b7b21e$var$onWasItemClick, false);
    });
}
function $54b47fc030b7b21e$var$onWasItemClick(e) {
    const wasBtns = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("wasHeader").querySelectorAll(".was-header-item p");
    wasBtns.forEach((btn)=>{
        btn.classList.remove("was-header-item-change");
    });
    this.querySelector("p").classList.add("was-header-item-change");
    $54b47fc030b7b21e$var$adjustWasMenu(this);
    const cat = this.getAttribute("data-target");
    const blocks = $54b47fc030b7b21e$var$main.querySelectorAll(".content-block");
    blocks.forEach((block)=>{
        block.classList.add("no-display");
    });
    const targets = Array.from(blocks).filter((block)=>block.getAttribute("data-cat").toLowerCase() === cat.toLowerCase());
    targets.forEach((target)=>{
        target.classList.remove("no-display");
    });
    document.documentElement.scrollTop = 0;
}
function $54b47fc030b7b21e$var$adjustWasMenu(item) {
    const bounds = item.getBoundingClientRect();
    const padding = window.innerWidth > 768 ? 60 : 12;
    (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("wasHeader").scrollLeft += bounds.x - padding;
}
//WILL-BE
function $54b47fc030b7b21e$var$handleUpcomingShows() {
    const rows = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("showsTable").querySelectorAll("tr");
    rows.forEach((r)=>{
        const rowDate = r.getAttribute("data-date");
        if (new Date(rowDate) <= new Date) return r.remove();
        const tdDate = r.querySelector(".td-date");
        tdDate.innerText = (0, $0b98cd1c57b9787e$export$3ae94a2503e890a1)(new Date(rowDate));
    });
    if ((0, $f64d5b2549d9d5cf$export$71511d61b312f219)("showsTable").querySelectorAll("tr").length === 0) $54b47fc030b7b21e$var$appendNoShows();
}
function $54b47fc030b7b21e$var$appendNoShows() {
    const tbody = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("showsTable").querySelector("tbody");
    const tr = (0, $f64d5b2549d9d5cf$export$3d7cd8ed57263b30)("tr", "flex-container flex-col flex-center");
    const td = (0, $f64d5b2549d9d5cf$export$3d7cd8ed57263b30)("td", "");
    td.innerHTML = "No upcoming shows at the moment<br><br>TBA soon";
    tr.append(td);
    tbody.append(tr);
}
//CONTACT
function $54b47fc030b7b21e$var$addContactListeners() {
    (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("contactForm").addEventListener("submit", $54b47fc030b7b21e$var$onContactSubmit, false);
    const inputs = $54b47fc030b7b21e$var$main.querySelectorAll(".input-fields");
    inputs.forEach((input)=>{
        input.addEventListener("keyup", $54b47fc030b7b21e$var$onInput, false);
    });
    (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("resultOverlay").addEventListener("click", $54b47fc030b7b21e$var$onOverlayClick, false);
}
function $54b47fc030b7b21e$var$onInput(e) {
    this.classList.add("validate");
}
async function $54b47fc030b7b21e$var$onContactSubmit(e) {
    e.preventDefault();
    document.querySelector(":root").classList.add("no-pointers");
    (0, $f64d5b2549d9d5cf$export$e85650ebb7296dad)(true, (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("submitBtn"));
    const payload = {
        fullName: this.name.value.trim(),
        email: this.email.value.trim(),
        message: this.message.value.trim()
    };
    const formSubmissionResult = await $54b47fc030b7b21e$var$submitForm(payload);
    document.querySelector(":root").classList.remove("no-pointers");
    (0, $f64d5b2549d9d5cf$export$e85650ebb7296dad)(false, (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("submitBtn"));
    $54b47fc030b7b21e$var$onServerResult(this, formSubmissionResult);
}
async function $54b47fc030b7b21e$var$submitForm(payload) {
    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    };
    try {
        const response = await fetch("https://aminobelyamani.xyz/ab-contact", options);
        return await response.json();
    } catch (err) {
        console.error(err);
        return {
            success: false,
            error: "An unexpected error occured<br><br>Please check your internet connection"
        };
    }
}
function $54b47fc030b7b21e$var$onServerResult(form, result) {
    (0, $f64d5b2549d9d5cf$export$82e6205b15e6c637)((0, $f64d5b2549d9d5cf$export$71511d61b312f219)("resultOverlay"), true);
    document.querySelector(":root").classList.add("no-scroll");
    const resultMsg = (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("resultOverlay").querySelector(".result-msg");
    if (result.success) {
        resultMsg.classList.remove("error");
        $54b47fc030b7b21e$var$resetForm(form);
        resultMsg.innerHTML = "thank you, your message was sent successfully";
        return;
    }
    resultMsg.classList.add("error");
    resultMsg.innerHTML = result.error;
}
function $54b47fc030b7b21e$var$resetForm(form) {
    form.reset();
    form.message.style.height = "";
    const inputs = $54b47fc030b7b21e$var$main.querySelectorAll(".input-fields");
    inputs.forEach((input)=>{
        input.classList.remove("validate");
    });
}
function $54b47fc030b7b21e$var$onOverlayClick(e) {
    if (e.target.classList.contains("overlay")) {
        document.querySelector(":root").classList.remove("no-scroll");
        (0, $f64d5b2549d9d5cf$export$c091916f1530334c)((0, $f64d5b2549d9d5cf$export$71511d61b312f219)("resultOverlay"));
    }
}
//HAMBURGER
function $54b47fc030b7b21e$var$toggleHamb(e) {
    this.classList.toggle("change");
    if ($54b47fc030b7b21e$var$nav.classList.contains("nav-transform")) return $54b47fc030b7b21e$var$nav.classList.remove("nav-transform");
    $54b47fc030b7b21e$var$nav.classList.add("nav-transform");
}
//IMAGE OVERLAY
function $54b47fc030b7b21e$var$onImgOverlay(e) {
    const newDim = $54b47fc030b7b21e$var$getImgDimensions(this);
    const width = newDim.width;
    const height = newDim.height;
    const album = $54b47fc030b7b21e$var$imgOverlay.querySelector("img");
    //reset image
    album.removeAttribute("src");
    document.querySelector(":root").style.setProperty("--imgWidth", "0px");
    document.querySelector(":root").style.setProperty("--imgHeight", "0px");
    //set image
    album.setAttribute("src", this.getAttribute("src"));
    album.setAttribute("alt", this.getAttribute("alt"));
    (0, $f64d5b2549d9d5cf$export$71511d61b312f219)("imgCaption").innerHTML = this.getAttribute("alt");
    document.querySelector(":root").style.setProperty("--imgWidth", width + "px");
    document.querySelector(":root").style.setProperty("--imgHeight", height + "px");
    (0, $f64d5b2549d9d5cf$export$85f1bfb258290b46)($54b47fc030b7b21e$var$imgOverlay, $54b47fc030b7b21e$var$imgOverlay, "image-overlay-change");
}
function $54b47fc030b7b21e$var$getImgDimensions(img) {
    const bounds = img.getBoundingClientRect();
    const width = bounds.width;
    const height = bounds.height;
    var newWidth, newHeight;
    if (height > width) {
        const ratio = width / height;
        newHeight = Math.min(window.innerHeight - 150, height);
        newWidth = Math.min(window.innerWidth - 60, newHeight * ratio);
    } else newWidth = Math.min(window.innerWidth - 60, window.innerHeight - 150);
    return {
        width: newWidth,
        height: newHeight
    };
}
//VIDEO THUMBS
function $54b47fc030b7b21e$var$onVidClick(e) {
    const src = this.getAttribute("data-src");
    if (src.length === 0) return;
    const thumb = this.querySelector(".thumb-wrapper");
    this.replaceChild($54b47fc030b7b21e$var$appendVideo(src), thumb);
}
function $54b47fc030b7b21e$var$appendVideo(src) {
    const ifr = (0, $f64d5b2549d9d5cf$export$3d7cd8ed57263b30)("iframe", "");
    ifr.setAttribute("src", src);
    ifr.setAttribute("frameborder", "0");
    ifr.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
    ifr.setAttribute("allowfullscreen", "");
    return ifr;
}
//RESIZE
window.addEventListener("resize", $54b47fc030b7b21e$var$onResize, false);
function $54b47fc030b7b21e$var$onResize() {
    const vh = window.innerHeight / 100;
    document.querySelector(":root").style.setProperty("--vh", vh + "px");
}
$54b47fc030b7b21e$var$onResize();


//# sourceMappingURL=aicha.5e72ce1c.js.map
